import { render } from "./hotel.vue?vue&type=template&id=327ccd2e"
import script from "./hotel.vue?vue&type=script&lang=js"
export * from "./hotel.vue?vue&type=script&lang=js"

import "./hotel.vue?vue&type=style&index=0&id=327ccd2e&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__